export const MenuTemplateRoute = (() => {

    const Template = [
        { path: "Index", name: "首頁", page: "Index", value: "Y", children: [] }
    ];

    return {
        Template
    };
})();